module.exports = __webpack_public_path__ + "media/images/emoticons/subway-7258dc007217f8bb41541e7b2a2b34a4.gif";